<template>
	<div v-if="!innerIsReview">
    <validation-provider
            v-slot="{ errors }"
            :name="label || 'This'"
            :rules="rules"
            v-bind="providerProps"
            v-show="innerShouldShow"
            :vid="'validate-'+fieldAssignmentId"
    >
        <v-select
                v-model="innerValue"
                v-bind="vProps"
                :chips="isMultiple"
                :deletable-chips="isMultiple"
                :multiple="isMultiple"
                :error-messages="errors"
                :items="items"
                :append-icon="settings && settings.add_link_to_item ? 'fa fa-external-link-alt' : undefined"
                @click:append="goTo()"
        >
            <template #label>
                <span v-if="innerLabel" v-html="innerLabel"></span>
            </template>
        </v-select>
    </validation-provider>
	</div>
	<div v-else>
		<type-review
				v-if="extraProps"
				:label="label"
				:directions="directions"
				:should-show="innerShouldShow"
				:show-edit-button="extraProps.editButton"
				:page-number="extraProps.originalPageNumber"
				@goToPage="goToPage($event)"
		>
			<div v-if="reviewValue">
				<span v-html="reviewValue"></span>
			</div>
			<div v-else>N/A</div>
		</type-review>
	</div>
</template>

<script>
    import $api from '@api/api';
    import formMixin from '../formMixin'
	import TypeReview from './TypeReview';

    export default {
        name: 'TypeSelect',
        mixins: [formMixin],
		components: {
			TypeReview
		},
        data() {
            return {
                innerItems: [],
				triggerUpdate:false
            }
        },
        methods: {
            goTo() {
                console.log('Should navigate to '+this.settings?.populate_db_item+' '+this.innerValue)
            }
        },
        async mounted() {
            if (this.settings?.populate_from_db) {
                this.innerItems = Bandwango.data[this.settings.populate_db_item];
                if (!this.innerItems) {
                    // const {data} = await $api[this.settings.populate_db_item]['get' + Bandwango.ucwords(this.settings.populate_db_item)]({select:['id', 'name']});

                    if( this.settings.populate_db_item === "venues" )
                        this.innerItems = (await $api.venues.getVenues({select: ['venues.id', 'venues.name']})).data;
					if (this.settings.populate_db_item === "roles")
						this.innerItems = (await $api.roles.getRoles({select: ['roles.id', 'roles.name']})).data;

                }
                this.vProps['item-text'] = 'name';
                this.vProps['item-value'] = 'id';
            }
            this.fieldLoaded(); // signal to the form we are loaded
        },
		watch:{
			value_options() {
				this.triggerUpdate = !this.triggerUpdate;
			}
		},
        computed: {
            defaults() {
                return {
                    label: this.innerLabel,
                    persistentHint: true,
                }
            },
            rules() {
                return (this.enableValidation) ? {
                    ...this.validation_settings,
                    ...{required: !!this.validation_settings.required && !!this.innerShouldShow}
                } : {}
            },
            isMultiple() {
                return this.type_attributes?.indexOf('Multiple') > -1
            },
            items() {
				this.triggerUpdate;
                return this.value_options?.length ? this.value_options : ( this.innerItems?.length ? this.innerItems : []);
			},
			reviewValue() {
				this.triggerUpdate;
				let f = this.items.find(x => x[this.vProps['item-value'] || 'id'] == this.innerValue);
				return this.innerIsReview && f && f[this.vProps['item-text'] || 'name'] || '';
            }
        },
    }
</script>
